import { render, staticRenderFns } from "./AuthorSelector.vue?vue&type=template&id=52f61df4"
import script from "./AuthorSelector.vue?vue&type=script&lang=js"
export * from "./AuthorSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports